export const name = 'HttpErrorException';

/**
 * Raised when the server answered with a non 2xx status.
 *
 * The request did reach the server, so this is NOT a connectivity problem and
 * must never be reported to the user as one.
 */
export default class HttpErrorException extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = name;
    this.status = status;
    this.body = body;
  }
}
